(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/react-conditionals/assets/javascripts/null.js') >= 0) return;  svs.modules.push('/components/lb-utils/react-conditionals/assets/javascripts/null.js');
"use strict";

const Null = () => null;
setGlobal('svs.components.lbUtils.reactConditionals.Null', Null);

 })(window);